import { useCallback, useRef } from 'react';
import { ITicker } from '@kattana-io/common';
import useTicker from '../../../hooks/useTicker';
import Text from '../../../atoms/Text';
import PairIcons from '../../../molecules/PairIcons';

interface IWatchlistTickerMobileProps {
  ticker: ITicker;
  active: boolean;
  actionRemoveWatchlist?: (id: number) => void;
}

const WatchlistTickerMobile = ({
  ticker,
  // active,
  actionRemoveWatchlist,
}: IWatchlistTickerMobileProps) => {
  const item = useTicker(ticker);
  const ref = useRef(null);

  const onUnfav = useCallback(
    (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      if (actionRemoveWatchlist) {
        actionRemoveWatchlist(ticker.id);
      }
    },
    [item]
  );

  return (
    <div ref={ref} className='ticker__cell'>
      <PairIcons
        chain={item.chain}
        pair={item.name}
        base_address={item.base_address}
        quote_address={item.quote_address}
        base_slug={item.base_slug}
        quote_slug={item.quote_slug}
      />
      <div className='name_exchange'>
        <Text size={14} className='text--weight-500 text--grey-400'>
          {item.name}
        </Text>
        <Text size={12} className='text--weight-500 text--grey-600'>
          {item.exchange}
        </Text>
      </div>
      {actionRemoveWatchlist && (
        <div
          className='star star--unfavourite icon-star-active'
          onClick={onUnfav}
        />
      )}
    </div>
  );
};

export default WatchlistTickerMobile;
